import { render } from "./Animal.vue?vue&type=template&id=a7519f66&scoped=true"
import script from "./Animal.vue?vue&type=script&lang=js"
export * from "./Animal.vue?vue&type=script&lang=js"

import "./Animal.vue?vue&type=style&index=0&id=a7519f66&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7519f66"]])

export default __exports__